import React, { FC } from "react";

import "./WizardHeader.scss";

interface WizardHeaderProps {
  title?: string;
  description?: string;
  canAddLater?: boolean;
  link?: string;
  linkTitle?: string;
}

const WizardHeader: FC<WizardHeaderProps> = ({
  title,
  description,
  canAddLater,
  link,
  linkTitle,
}) => {
  return (
    <div className="wizard-header">
      <p className="wizard-header__title">
        {title} {canAddLater && <span>You can add this later.</span>}
      </p>
      <p className="wizard-header__description">
        {description}{" "}
        <span>
          <a href={`${link}`} target="_blank" rel="noreferrer">
            {linkTitle}
          </a>
        </span>
      </p>
    </div>
  );
};

export default WizardHeader;
